import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const StatusResultRow = ({ row }) => (
  <Fragment>
    {`${row.status} (#: ${row.docket_no})`}
    {row.status_set_by &&
      <div>Set By: {row.status_set_by}</div>
    }
    {row.date_status_begin &&
      <div>Begin Date: {row.date_status_begin}</div>
    }
    {row.time_in_status &&
      <div>Time in Status: {row.time_in_status}</div>
    }
  </Fragment>
);

StatusResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default StatusResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/StatusResultRow.jsx